(function(angular, schoolwork12) {
'use strict';
angular.module(schoolwork12.app.fulfillment.name)
    .factory('getSchools', ['$http', '$q', function ($http, $q)

        {
            	//var allSchoolList = null;
           	var getAllSchoolsList = function (keycode) {
                console.info('In get Schools service call');
                console.info('Making a call to service');
                var allSchoolList = null;
                var deferred = $q.defer();
                var request = $http({
                    cache:true,
                    method: 'GET',
                    url: schoolwork12.app.fulfillment.endpoints.getAllSchoolsEndpoint,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    console.info('Got the school list');
                    allSchoolList = response.data;
                    deferred.resolve(allSchoolList);
                }, function (error) {
                	console.info("Error occured while getting list of school service");
                    deferred.reject(error);
                });
                return deferred.promise;
                //return allSchoolList;
            };
            
            var getConfiguredSchoolList = function (keycode) {
                console.info('In getConfiguredSchoolList service');
                console.info('Making a call to service');
                var configuredSchoolList = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'GET',
                    url: schoolwork12.app.fulfillment.endpoints.fulfillmentConfiguredSchools,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    console.info('Got the school list');
                    configuredSchoolList = response.data;
                    deferred.resolve(configuredSchoolList);
                }, function (error) {
                	console.error("Error occured while calling fulfillmwnt configured school list service");
                    deferred.reject(error);
                });
                return deferred.promise;
                //return allSchoolList;
            };
            
             var getConfiguredSchoolDetails = function (keycode, startDate, endDate, schoolId) {
                console.info('In getConfigurationSchoolDetails service');
                console.info('Making a call to service');
                var configuredSchoolsDetails= null;
                var data = {
                   ruleStartDate :  startDate,
                   ruleEndDate   :  endDate,
                };
                var deferred = $q.defer();
                var request = $http({
                    method: 'GET',
                    url: schoolwork12.app.fulfillment.endpoints.fulfillmentConfiguredSchools.concat('/').concat(schoolId),
                    params : data,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    console.info('Got the school details');
                    configuredSchoolsDetails = response.data;
                    deferred.resolve(configuredSchoolsDetails);
                }, function (error) {
                	console.info("Error occured while getting confiured school details");
                    deferred.reject(error);
                });
                return deferred.promise;               
            };
            
            var getBundleTypes = function (keycode) {
                console.info('In get bundle types service');
                console.info('Making a call to service');
                var bundleTypes = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'GET',
                    url: schoolwork12.app.fulfillment.endpoints.fulfillmentBundleTypes,                   
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    console.info('Got bundle types');
                    bundleTypes = response.data;
                    deferred.resolve(bundleTypes);
                }, function (error) {
                	console.error("Error occured while getting bundle types");
                    deferred.reject(error);
                });
                return deferred.promise;               
            };
            
            var updateFulfillmentDetails = function (keycode, schoolId, data) {
                console.info(" calling update fulfillment details for school : "+schoolId);                
                var updateAuthpromise = null;                
                var deferred = $q.defer();
                var request = $http({
                    method: 'PUT',
                    url: schoolwork12.app.fulfillment.endpoints.fulfillmentConfiguredSchools.concat('/').concat(schoolId),
                    data : data,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    console.info('Got a response from update method for school '+schoolId);
                    updateAuthpromise = response.data;
                    deferred.resolve(updateAuthpromise);
                }, function (error) {
                	console.info("Error while updating fulfillment details for school "+schoolId);
                    deferred.reject(error);
                });
                return deferred.promise;               
            };
            
            var recalculateSchool = function (keycode, schoolId, data) {
                console.info(" calling recalculateSchool for school : "+schoolId);                
                var recalculateAuthpromise = null;                
                var deferred = $q.defer();
                var request = $http({
                    method: 'PUT',
                    url: schoolwork12.app.fulfillment.endpoints.reCalculateConfiguredSchool.concat('/').concat(schoolId),
                    data : data,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    console.info('Got a response from recalculate method for school '+schoolId);
                    recalculateAuthpromise = response.data;
                    deferred.resolve(recalculateAuthpromise);
                }, function (error) {
                	console.info("Error while recalculate for school "+schoolId);
                    deferred.reject(error);
                });
                return deferred.promise;               
            };
            
            return {
                getAllSchoolsList: getAllSchoolsList,
                getConfiguredSchoolList: getConfiguredSchoolList,
                getConfiguredSchoolDetails:getConfiguredSchoolDetails,
                getBundleTypes:getBundleTypes,
                updateFulfillmentDetails:updateFulfillmentDetails,
                recalculateSchool:recalculateSchool,
            };

        }]);
}(angular, schoolwork12));